import { useTranslation } from 'react-i18next';
import { Bar, BarChart, CartesianGrid, LabelList, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui-kit/card';
import { CategoryScore, PerformanceDashboard } from '../../types/dashboard.types';

export interface WeightedCategoryBarsProps {
  dashboard: PerformanceDashboard;
}

export const WeightedCategoryBars = ({ dashboard }: WeightedCategoryBarsProps) => {
  const { t } = useTranslation();

  let categories: CategoryScore[] = [];
  try {
    categories = JSON.parse(dashboard.CategoryScoresJson) as CategoryScore[];
  } catch {
    categories = [];
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('CATEGORY_SCORES')}</CardTitle>
      </CardHeader>
      <CardContent className="overflow-x-clip">
        <ResponsiveContainer width="100%" height={Math.max(categories.length * 36, 120)}>
          <BarChart data={categories} layout="vertical" margin={{ left: 0, right: 24 }}>
            <CartesianGrid horizontal={false} stroke="oklch(var(--border))" />
            <XAxis type="number" domain={[0, 4]} tick={{ fontSize: 12 }} />
            <YAxis type="category" dataKey="Category" width={112} tick={{ fontSize: 12 }} />
            <Tooltip formatter={(value: number) => value.toFixed(2)} />
            <Bar dataKey="Score" fill="oklch(var(--primary))" radius={[0, 4, 4, 0]} maxBarSize={18}>
              <LabelList dataKey="Score" position="right" formatter={(value: number) => value.toFixed(1)} />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};
